import axios from 'axios'

/**
 * Request password reset
 * @param {Object} data Data
 * @param {String} data.email User email
 */
function requestReset (data) {
  return axios
    .post('rest-auth/password-reset/', {
      email: data.email
    })
}

/**
 * Set new password
 * @param {Object} data Data
 * @param {String} data.token Reset token
 * @param {String} data.password New password
 */
function setNew (data) {
  return axios
    .post('rest-auth/password-reset/confirm/', {
      token: data.token,
      password: data.password
    })
}

export default {
  requestReset,
  setNew
}
